import { CreateApiResponse, FetchApiResponse } from "redux/types";

export enum ExcessMoneyRefundTypes {
    CREATE_EXCESS_MONEY_REFUND = "@@auth/CREATE_EXCESS_MONEY_REFUND",
    CREATE_EXCESS_MONEY_REFUND_SUCCESS = "@@auth/CREATE_EXCESS_MONEY_REFUND_SUCCESS",
    CREATE_EXCESS_MONEY_REFUND_ERROR = "@@auth/CREATE_EXCESS_MONEY_REFUND_ERROR",

    EXCESS_MONEY_REFUND_APPROVE = "@@auth/EXCESS_MONEY_REFUND_APPROVE",
    EXCESS_MONEY_REFUND_APPROVE_SUCCESS = "@@auth/EXCESS_MONEY_REFUND_APPROVE_SUCCESS",
    EXCESS_MONEY_REFUND_APPROVE_ERROR = "@@auth/EXCESS_MONEY_REFUND_APPROVE_ERROR",

    EXCESS_MONEY_REFUND_REJECT = "@@auth/EXCESS_MONEY_REFUND_REJECT",
    EXCESS_MONEY_REFUND_REJECT_SUCCESS = "@@auth/EXCESS_MONEY_REFUND_REJECT_SUCCESS",
    EXCESS_MONEY_REFUND_REJECT_ERROR = "@@auth/EXCESS_MONEY_REFUND_REJECT_ERROR",

    RESET_CREATE_MONEY_REFUND = "@@auth/RESET_CREATE_MONEY_REFUND",
    RESET_APPROVE_MONEY_REFUND = "@@auth/RESET_APPROVE_MONEY_REFUND",
    RESET_REJECT_MONEY_REFUND = "@@auth/RESET_REJECT_MONEY_REFUND"
}

export type ExcessMoneyRefundActionDispatch = {
    type :
    | ExcessMoneyRefundTypes.CREATE_EXCESS_MONEY_REFUND
    | ExcessMoneyRefundTypes.CREATE_EXCESS_MONEY_REFUND_SUCCESS
    | ExcessMoneyRefundTypes.CREATE_EXCESS_MONEY_REFUND_ERROR

    | ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_APPROVE
    | ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_APPROVE_SUCCESS
    | ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_APPROVE_ERROR

    | ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_REJECT
    | ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_REJECT_SUCCESS
    | ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_REJECT_ERROR

    | ExcessMoneyRefundTypes.RESET_CREATE_MONEY_REFUND
    | ExcessMoneyRefundTypes.RESET_APPROVE_MONEY_REFUND
    | ExcessMoneyRefundTypes.RESET_REJECT_MONEY_REFUND


    payload: any;
}

export type ExcessMoneyRefundReducerDispatch = {
    type : 
    | ExcessMoneyRefundTypes.CREATE_EXCESS_MONEY_REFUND
    | ExcessMoneyRefundTypes.CREATE_EXCESS_MONEY_REFUND_SUCCESS
    | ExcessMoneyRefundTypes.CREATE_EXCESS_MONEY_REFUND_ERROR

    | ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_APPROVE
    | ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_APPROVE_SUCCESS
    | ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_APPROVE_ERROR

    | ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_REJECT
    | ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_REJECT_SUCCESS
    | ExcessMoneyRefundTypes.EXCESS_MONEY_REFUND_REJECT_ERROR

    | ExcessMoneyRefundTypes.RESET_CREATE_MONEY_REFUND
    | ExcessMoneyRefundTypes.RESET_APPROVE_MONEY_REFUND
    | ExcessMoneyRefundTypes.RESET_REJECT_MONEY_REFUND

    payload: {
        data?: FetchApiResponse<ExcessMoneyRefund>
        error?: string
    }
}

//use by reducer
export type ExcessMoneyRefundReduxState = {
    loading ?: boolean;
    data ?: FetchApiResponse<ExcessMoneyRefund>
    error ?: string | null
}

export type ExcessMoneyRefund = {
    // id: string;
    // financierId: string;
    // creatorUserId: string;
    // approveUserId: string;
    repaymentExcessMoneyId: string;
    actionDate: string;
    action: string;
    paymentInstrumentId: string;
    refundAccountNumber: string;
    refundAccountIfscCode: string;
    refundAmount: number;
    makerRemarks: string;
    checkerRemarks: string;
    status: string;
    createdOn: string;
    updatedOn: string;
    makerUser: MakerUser;
    checkerUser: CheckerUser;
    paymentInstrument: PaymentInstrumentExcessMoneyRefund
}
export type MakerUser = {
    id: string,
    name: string,
    externalId: string
}

export type CheckerUser = {
    id: string,
    name: string,
    externalId: string
}

export type PaymentInstrumentExcessMoneyRefund = {
    id: string,
    instrumentNumber: string,
    fundingAmount: bigint
}

export type CreateExcessMoneyRefund = {
    repaymentExcessMoneyId:string;
    refundAmount:number
    refundAccountNumber:string
    refundIfscCode:string
    makerRemarks:string
}

export type CreateExcessMoneyRefundReduxState = {
    loading?: boolean;
    data ?: CreateApiResponse<ExcessMoneyRefund>
    error ?: string | null;
}

export type CreateExcessMoneyRefundRequest = {
    payload: CreateExcessMoneyRefund
    type: string
}

export type ApproveRejectExcessMoneyRefund = {
    checkerRemarks: string
}
export type ApproveRejectExcessMoneyRefundRequest = {
    payload: ApproveRejectExcessMoneyRefund;
    type: string
}